import { Box, Typography } from '@mui/material'
import { sectionTitleRowActionLabelSx, sectionTitleRowActionSx } from './sectionTitleRowSx.js'

export function SectionTitleRowAction({ actionText, actionFilled, onActionClick }) {
  if (!actionText) return null

  return (
    <Box
      component="span"
      role={onActionClick ? 'button' : undefined}
      tabIndex={onActionClick ? 0 : undefined}
      onClick={(event) => {
        event.stopPropagation()
        onActionClick?.()
      }}
      onKeyDown={(event) => {
        if (!onActionClick) return
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onActionClick()
        }
      }}
      sx={sectionTitleRowActionSx(actionFilled, onActionClick)}
    >
      <Typography component="span" sx={sectionTitleRowActionLabelSx}>
        {actionText}
      </Typography>
    </Box>
  )
}
